import * as React from 'react'
import { Box, Typography, TypographyProps } from 'cs-kevlar-react'
import {
  makeStyles,
  createStyles,
  Theme,
} from 'cs-kevlar-react/lib/es/theming/theme'

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    text: {
      marginLeft: theme.spacing(2),
    },
    root: {
      display: 'flex',
      alignItems: 'center',
      color: theme.palette.neutral.contrastText,
    },
  }),
)

interface IconTextProps {
  icon: (props: any) => JSX.Element
  typographyProps?: TypographyProps
  text: string
}

export const IconText: React.FunctionComponent<IconTextProps> = ({
  icon,
  typographyProps,
  text,
}) => {
  const classes = useStyles({})

  const Icon = icon

  const textProps = typographyProps ? typographyProps : {}

  return (
    <Box className={classes.root}>
      <Icon />
      <Typography
        variant="body1"
        noWrap
        className={classes.text}
        {...textProps}
      >
        {text}
      </Typography>
    </Box>
  )
}
